import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import styles from './index.module.scss'

interface Props {
  label: string
  subtitle?: string
  sortable?: boolean
  options: React.ReactNode
}

const cx = classNames.bind(styles)

const BoxListItem = (props: Props) => {
  const dragHandle = props.sortable ? (
    <div className={styles.dragHandle}>
      <Icon.Medium icon="drag-and-drop" />
    </div>
  ) : null

  return (
    <div
      className={cx(styles.item, {
        sortable: props.sortable,
      })}
    >
      {dragHandle}
      <div className={styles.textBlock}>
        <h2
          className={cx(styles.title, {
            hasSubtitle: props.subtitle,
          })}
        >
          {props.label}
        </h2>
        {props.subtitle && <h3 className={styles.subtitle}>{props.subtitle}</h3>}
      </div>
      <div className={styles.actions}>{props.options}</div>
    </div>
  )
}

export default BoxListItem
